// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incyia-number-input {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.incyia-number-input-field {
  width: 100%;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.incyia-number-input.has-suffix .incyia-number-input-field {
  padding-right: 44px !important;
}

.incyia-number-edit-cell {
  width: 100%;
  height: 100%;
  border: 0;
  outline: none;
  padding: 0 10px;
  font: inherit;
  text-align: left;
  font-variant-numeric: tabular-nums;
  background: transparent;
}

.incyia-number-input-suffix {
  position: absolute;
  right: 12px;
  font-size: 0.92em;
  font-weight: 700;
  color: #5f7484;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/NumberInput.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB","sourcesContent":[".incyia-number-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.incyia-number-input-field {\n  width: 100%;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.incyia-number-input.has-suffix .incyia-number-input-field {\n  padding-right: 44px !important;\n}\n\n.incyia-number-edit-cell {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  outline: none;\n  padding: 0 10px;\n  font: inherit;\n  text-align: left;\n  font-variant-numeric: tabular-nums;\n  background: transparent;\n}\n\n.incyia-number-input-suffix {\n  position: absolute;\n  right: 12px;\n  font-size: 0.92em;\n  font-weight: 700;\n  color: #5f7484;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
